export const COUNTRY_IDS = {
  GL: "55BBF40F-3693-478E-948A-FB2321DB7771",
  AMK: "55BBF40F-3693-478E-948A-FB2321DB7771",
  LMK: "4298F454-C79C-45E7-8FAF-3DDFE9440F46",
  RN: "D08EA478-447C-4A66-B9EC-D6ABD3697C02",
} as const;
